export default {
  CAMPAIGN_OVER: "/campaign-over",
  CAMPAIGN_TEASER: "/campaign-teaser",
  INVALID_CHANNEL: "/invalid-channel",
  SUCCESS: "/success",
  USER_DETAILS: "/user-details",
  CANCELLED: "/cancelled",
  ERROR: "/error",
  NO_OOJI_DATA: "/no-ooji-data",
  NO_SUPPORT: "/no-support",
  STOCK_OUT: "/stock-out",
  ALREADY_ORDERED: "/already-ordered",
  TOO_MUCH_DEMAND: "/too-much-demand",
  RATE_LIMIT: "/rate-limit",
  RATE_LIMIT_WITH_COUNTDOWN: "/rate-limit-with-countdown",
  UNLUCKY: "/unlucky",
  LINK_USED: "/link-used",
  LINK_EXPIRED: "/link-expired",
  BOT_DETECTED: "/bot-detected",
  RESTRICTED_CAMPAIGN_INFO: "/restricted-campaign-info",
  TOO_YOUNG: "/too-young",
  ADDRESS: "/address-details",
  AUTHENTICATION_ERROR: "/authentication-error",
  RULES: "/rules",
  REVIEW_DETAILS: "/review",
  VERIFY_EMAIL: "/verify-email",
  MENU: "/menu",
  REMINDER: "/reminder",
  CHECK_AGE: "/check-age",
  SURVEY: "/survey",
  ENTRY_GATE: "/entry-gate",
  FOLLOW_UP_SURVEY: "/follow-up-survey",
  PROGRESS: "/progress",
  EMAIL_VERIFIED: "/email-verified",
  EMAIL_VERIFICATION_FAILED: "/email-verification-failed",
  INFO: "/info",
  EXTRA_INFO: "/extra-info",
  SKILL_TEST: "/skill-test",
  DELIVERY_ZONES: "/delivery-zones",
  UPLOAD_FILE: "/upload-file",
  SECONDARY_CHANNEL: "/secondary-channel",
  COD_AUTH: "/cod-auth",
  INVALID_ENTRY: "/invalid-entry",
  UNSUPPORTED_BROWSER: "/unsupported-browser",
  ROOT: "/"
};
